import api from './client';

export const shareBikeAnalysis = async (analysisSessionId, { displayName, description, isAnonymous } = {}) => {
  const response = await api.post('/analyses/share', {
    analysis_session_id: analysisSessionId,
    display_name: displayName || null,
    description: description || null,
    is_anonymous: isAnonymous ?? false,
  });
  return response.data;
};

export const getSharedBikeAnalysis = async (shareId) => {
  const response = await api.get(`/shared/analysis/${shareId}`);
  return response.data;
};

export const unshareBikeAnalysis = async (shareId) => {
  const response = await api.delete(`/shared/analysis/${shareId}`);
  return response.data;
};
